/* Pastime Goods Luxe: tiny progressive-enhancement layer. No dependencies. */
(() => {
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Header glass state
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      root.toggleAttribute('data-lx-scrolled', scrollY > 24);
      ticking = false;
    });
  };
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Reveal on scroll
  const reveal = () => {
    const els = document.querySelectorAll('[data-lx-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  };

  // Product rails: arrow buttons + disabled state
  const rails = () => {
    document.querySelectorAll('[data-lx-rail]').forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const section = wrap.closest('section') || document;
      const track = wrap.querySelector('.lx-rail');
      const prev = section.querySelector('[data-dir="prev"]');
      const next = section.querySelector('[data-dir="next"]');
      if (!track) return;
      const step = () => track.clientWidth * 0.8;
      const sync = () => {
        if (prev) prev.disabled = track.scrollLeft < 8;
        if (next) next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
      };
      prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      new ResizeObserver(sync).observe(track);
      sync();
    });
  };

  const init = () => { reveal(); rails(); };
  document.readyState === 'loading' ? addEventListener('DOMContentLoaded', init) : init();
  // Re-run inside the theme editor when sections reload
  addEventListener('shopify:section:load', init);
})();
